module.exports = __webpack_public_path__ + "static/ring-planet-bg-6154ded93e02a8410ccbf2e5b81033bf.png";